// @ts-nocheck

import { useEffect, useState } from "react"
import SettingPopup from "./SettingPopup"
import SwapPanel from "./Swap/SwapPanel"
import { SwapWidgetProps } from "../SwapWidget"
import useSettings from "../hooks/useSettings"
import LogoDark from "../assets/logo-dark.png"
import LogoLight from "../assets/logo-light.png"
import Rhino from "../assets/rhino.png"
import ExternalLink from "./svgs/ExternalLink"
import SwapComp from "./Swap/SwapComp"
import useTheme from "../hooks/useTheme"
import { Toaster } from "react-hot-toast"

const Swap = ({
  amount,
  inputToken,
  outputToken,
  width,
  darkMode,
  slippage,
  hideBridge,
}: SwapWidgetProps) => {
  const { setSlippage } = useSettings()
  const { setDarkMode } = useTheme()

  useEffect(() => {
    setSlippage(slippage ?? 0.5)
  }, [slippage])

  useEffect(() => {
    setDarkMode(Boolean(darkMode))
  }, [darkMode])

  return (
    <>
      <div
        id="superswap-widget"
        className={`p-2.5 ${
          darkMode ? "bg-[#080d15]" : "bg-[#f4f6fc]"
        } w-fit h-fit text-left rounded-xl`}
        style={{
          width: `${width ?? 480}px`,
          fontFamily: "Roobert, sans-serif",
        }}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <button
              className={`bg-transparent rounded-full ${
                darkMode ? "text-white bg-[#131823]" : "text-[#1f1d1a] bg-white"
              } py-3 px-4 font-semibold`}
            >
              Swap
            </button>
            {!hideBridge ? (
              <button
                className={`flex items-center bg-transparent rounded-full ${
                  darkMode
                    ? "text-white bg-[#131823]"
                    : "text-[#1f1d1a] bg-white"
                } py-3 px-4 font-semibold`}
                onClick={() => {
                  window.open(
                    "https://app.rhino.fi/bridge/?refId=DeFi_SuperSwap&token=ETH&chainOut=INK&chainIn=BASE",
                    "_blank"
                  )
                }}
              >
                <img src={Rhino} alt="rhino" className="w-5 mr-1.5" />
                Bridge
                <ExternalLink className="size-4 ml-1" />
              </button>
            ) : null}
          </div>
          <SettingPopup />
        </div>
        <SwapPanel
          amount={amount}
          inputToken={inputToken}
          outputToken={outputToken}
        />
        <div
          className={`flex items-center justify-center text-sm ${
            darkMode ? "text-white" : "text-black"
          }  mt-3 opacity-60`}
          style={{ fontFamily: "PPMori, sans-serif" }}
        >
          Powered by{" "}
          <a
            href="https://superswap.ink"
            rel="noreferrer"
            target="_blank"
            className="flex items-center"
          >
            {darkMode ? (
              <img src={LogoDark} alt="logo" className="h-4 mx-1.5" />
            ) : (
              <img src={LogoLight} alt="logo" className="h-4 mx-1.5" />
            )}
            <b>SuperSwap</b>
          </a>
        </div>
      </div>
      <Toaster />
    </>
  )
}

export default Swap
